import axios, { AxiosError } from "axios"

import { ENV } from "./env"
import { clearAuth, readAuth } from "./auth"

/**
 * Axios client for the admin backend (`/admin/*` routes).
 *
 * Mirrors the legacy admin's Helper/API.jsx behavior:
 *   - Authorization header injected from auth_data on every request
 *   - 401 response → clear stored auth + replace location to /login
 *
 * Notes:
 *   - The legacy backend returns 404 (not 401) on a wrong-credentials login.
 *     The interceptor below only catches 401, so a failed login still bubbles
 *     up to the Login page's error handler (correct behavior — don't redirect
 *     someone who's still on the login screen).
 *   - The same instance handles both `/admin/login` (no token needed; the
 *     header is just empty) and authenticated routes.
 */
export const api = axios.create({
  baseURL: ENV.API_BASE_URL,
})

export const uploadApi = axios.create({
  baseURL: ENV.UPLOAD_BASE_URL,
})

api.interceptors.request.use((config) => {
  const auth = readAuth()
  config.headers = config.headers ?? {}
  config.headers.Authorization = auth ? auth.token : ""
  return config
})

api.interceptors.response.use(
  (response) => response,
  (error: AxiosError) => {
    if (error?.response?.status === 401) {
      clearAuth()
      if (
        typeof window !== "undefined" &&
        window.location.pathname !== "/login"
      ) {
        window.location.replace("/login")
      }
    }
    return Promise.reject(error)
  }
)
